import {ErrorHandler, NgModule} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {CommonModule} from '@angular/common';
import {SignagePlayerPwa} from "./SignagePlayer/signage.player.pwa";
import {PlayerPwaService} from "./services/PlayerService/player.pwa.service";
import {CachingService} from "./services/caching/caching.service";
import {InstallPwaComponent} from "./reg/install-pwa/install-pwa.component";
import {HostServerComponent} from "./reg/host-server/host-server.component";
import {LoginComponent} from "./reg/login/login.component";
import {RegistrationComponent} from "./reg/registration/registration.component";
import {TaskbarComponent} from "./taskbar/taskbar.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CloseComponent} from "./reg/close/close.component";
import {SignageInfoComponent} from "./taskbar/info/signage-info.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {QRCodeModule} from "angularx-qrcode";
import {EventParams} from "./services/EventParams/event.params";
import {SignageLibsModuleCommon} from "./signage-libs.module.common";
import {CheckIsInstalledComponent} from "./reg/check-is-installed/check.is.installed.component";
import {MatTabsModule} from "@angular/material/tabs";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {DialogPopComponent} from "./taskbar/dialog-pop/dialog-pop.component";
import {CheckInternetConnectionComponent} from "./reg/check-internet-connection/check.internet.connection.component";
import {GlobalErrorHandler} from "./services/GlobalErrorHandler";


@NgModule({
    declarations: [
        SignagePlayerPwa,
        InstallPwaComponent,
        CheckIsInstalledComponent,
        CloseComponent,
        HostServerComponent,
        LoginComponent,
        RegistrationComponent,
        SignageInfoComponent,
        DialogPopComponent,
        TaskbarComponent,
        CheckInternetConnectionComponent
    ],
    imports: [
        SignageLibsModuleCommon,
        CommonModule,
        ReactiveFormsModule,
        QRCodeModule,
        FormsModule,
        DragDropModule,
        MatTabsModule,
        ScrollingModule,
        MatAutocompleteModule,
    ],
    exports: [
        InstallPwaComponent,
        CheckIsInstalledComponent,
        CloseComponent,
        HostServerComponent,
        LoginComponent,
        RegistrationComponent,
        TaskbarComponent,
    ],
    providers: [
      {
        provide: ErrorHandler, useClass: GlobalErrorHandler
      },
      {
          provide: 'cachingService',
          useClass: CachingService
      },
      {
          provide: 'playerService',
          useClass: PlayerPwaService
      },
      {
          provide: 'eventParams',
          useClass: EventParams
      },
      {
          provide: MatDialogRef,
          useValue: {}
      }
    ],
    bootstrap: []
})
export class SignageLibsModulePwa {
}
